import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpParams,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { DataService, INTERCEPTOR_NOT_REQUIRED } from '../data.service';
import {
  ReplaySubject,
  catchError,
  from,
  map,
  switchMap,
  throwError,
} from 'rxjs';
let isRefreshingToken = false;
let tokenSubject = new ReplaySubject<null>(1);
export const paramAdderInterceptor: HttpInterceptorFn = (req, next) => {
  console.log('paramAdderInterceptor');
  const dataService = inject(DataService);
  const loggedUser = dataService.loggedUser;
  if (req.context.get(INTERCEPTOR_NOT_REQUIRED)) {
    return next(req);
  }
  const reqWithParam = req.clone({
    params: new HttpParams().set('auth', loggedUser?.idToken),
  });
  return next(reqWithParam).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        console.log('isRefreshingToken', isRefreshingToken);
        if (!isRefreshingToken) {
          isRefreshingToken = true;
          tokenSubject.next(null); // Clear previous value

          return refreshToken(dataService).pipe(
            switchMap(() => {
              dataService.showHideLoader(false);
              isRefreshingToken = false;
              return next(
                reqWithParam.clone({
                  params: new HttpParams().set(
                    'auth',
                    dataService.loggedUser.idToken
                  ),
                })
              ); // Retry original request
            }),
            catchError((err) => {
              isRefreshingToken = false;
              return throwError(() => err); // Refresh failed, re-throw error
            })
          );
        } else {
          // Wait for refresh to complete before retrying
          dataService.showHideLoader(false);

          return tokenSubject.pipe(
            switchMap(() =>
              next(
                reqWithParam.clone({
                  params: new HttpParams().set(
                    'auth',
                    dataService.loggedUser.idToken
                  ),
                })
              )
            )
          );
        }
      } else {
        dataService.showHideLoader(false);

        return throwError(() => error);
      }
    })
  );

  function refreshToken(authService: DataService) {
    return authService.refreshToken(authService.loggedUser).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
      map(() => null) // Signal completion even on error
      // shareReplay(1) // Share the same observable for all waiting requests
    );
  }
};
